// extracted by mini-css-extract-plugin
module.exports = {"main":"RegisterPage_main__2DIPA","button":"RegisterPage_button__1lZFi","message":"RegisterPage_message__2QzAA","error":"RegisterPage_error__Ln2FR"};